/* eslint-disable react/no-unknown-property */
import React from 'react';
import Container from '../../atoms/Container';
import Styles from './CarrosEletricosParaVoce.css';
import RedButton from '../../atoms/RedButton/RedButton';

function CarrosEletricosParaVoce() {
  return (
    <>
      <section id="carros-eletricos-para-voce">
        <Container>
          <h3 className="carros-eletricos-para-voce-super-title">
            Como apoiamos a <b>sustentabilidade</b>
          </h3>
          {/* <div className="carros-eletricos-circles-pra-vc-mb" /> */}
          {/* <div className="carros-eletricos-circles-pra-vc-ds" /> */}
          <div className="carros-eletricos-para-voce-contain">
            <picture>
              <source type="image/webp" srcSet="assets/carros-eletricos/img-pra-vc.webp" />
              <source type="image/png" srcSet="assets/carros-eletricos/img-pra-vc.png" />
              <img
                className="carros-eletricos-para-voce-img"
                src="assets/carros-eletricos/img-pra-vc.png"
                alt="veículos elétricos no brasil"
              />
            </picture>
            <div className="carros-eletricos-para-voce-texts">
              <h3 className="carros-eletricos-para-voce-title">Para você</h3>
              <p className="carros-eletricos-para-voce-description">
                Encontre as melhores condições de financiamento. Realize o sonho do carro híbrido ou
                elétricos com a segurança e facilidade que só o Santander oferece.
              </p>
              <RedButton
                className="carros-eletricos-para-voce-btn"
                href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=SF&int_medium=carros-eletricos:cta&int_campaign=simular#/dados-pessoais"
                target="_blank"
              >
                Simular
              </RedButton>
            </div>
          </div>
          {/* <p className="carros-eletricos-disclaimer">
            *Sujeito a análise de crédito e demais condições do produto no momento da contratação.
            Cupom válido para financiamento de veículos híbridos e elétricos 0km, somente se a
            proposta for aprovada por meio do link{' '}
            <a
              href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?utm_source=crm_fin&utm_medium=email&utm_campaign=crm-hibridos/eletricos-simularfinanciamento#/dados-pessoais"
              target="_blank"
            >
              www.santander.com.br/simularfinanciamento
            </a>
          </p> */}
        </Container>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default CarrosEletricosParaVoce;
